import * as ElcEcommEvents from './elc-ecomm';
import * as ELCServiceAppointmentBookingEvents from './fe-elc-service-appt-booking';
import * as ElcServiceCartEvents from './fe-elc-service-cart';
import * as ElcServiceCheckoutEvents from './fe-elc-service-checkout';
import * as ElcServiceCommunicationsEvents from './fe-elc-service-communications';
import * as ElcServiceForgotPasswordEvents from './fe-elc-service-forgot-password';
import * as ElcServiceOffersEvents from './fe-elc-service-offers';
import * as ElcServiceOrderHistoryEvents from './fe-elc-service-order-history';
import * as ElcServiceOrderEvents from './fe-elc-service-order';
import * as ElcServicePasswordStrengthEvents from './fe-elc-service-password-strength';
import * as ElcServicePaymentEvents from './fe-elc-service-payment';
import * as ElcServiceProdcatEvents from './fe-elc-service-prodcat';
import * as ElcServiceSaveForLaterEvents from './fe-elc-service-save-for-later';
import * as ElcServiceSearchEvents from './fe-elc-service-search';
import * as ElcServiceSignInEvents from './fe-elc-service-sign-in';
import * as ElcServiceSignUpEvents from './fe-elc-service-sign-up';
import * as ElcServiceStoresEvents from './fe-elc-service-stores';
import * as ElcServiceUserProfileEvents from './fe-elc-service-user-profile';
import * as ElcServiceAnalyticsEvents from './fe-elc-service-analytics';
import * as ElcServiceVtoEvents from './fe-elc-service-vto';
import * as ElcServiceRatingsReviewsEvents from './fe-elc-service-ratings-reviews';
import * as ElcCareEvents from './elc-care';
import * as ElcRampEvents from './elc-ramp';
import * as ElcVideoEvents from './elc-video';

const events = {
    ...ElcEcommEvents,
    ...ELCServiceAppointmentBookingEvents,
    ...ElcServiceCartEvents,
    ...ElcServiceCheckoutEvents,
    ...ElcServiceCommunicationsEvents,
    ...ElcServiceForgotPasswordEvents,
    ...ElcServiceOffersEvents,
    ...ElcServiceOrderHistoryEvents,
    ...ElcServiceOrderEvents,
    ...ElcServicePasswordStrengthEvents,
    ...ElcServicePaymentEvents,
    ...ElcServiceProdcatEvents,
    ...ElcServiceSaveForLaterEvents,
    ...ElcServiceSearchEvents,
    ...ElcServiceSignInEvents,
    ...ElcServiceSignUpEvents,
    ...ElcServiceStoresEvents,
    ...ElcServiceUserProfileEvents,
    ...ElcServiceAnalyticsEvents,
    ...ElcServiceVtoEvents,
    ...ElcServiceRatingsReviewsEvents,
    ...ElcCareEvents,
    ...ElcRampEvents,
    ...ElcVideoEvents
};
type ServiceEvents = ElcServiceCartEvents.ServiceCartEvents &
    ElcEcommEvents.ServiceElcEcommEvents &
    ELCServiceAppointmentBookingEvents.ServiceAppointmentBookingEvents &
    ElcServiceCheckoutEvents.ServiceCheckoutEvents &
    ElcServiceCommunicationsEvents.ServiceCommunicationsEvents &
    ElcServiceForgotPasswordEvents.ServiceForgotPasswordEvents &
    ElcServiceOffersEvents.ServiceOffersEvents &
    ElcServiceOrderHistoryEvents.ServiceOrderHistoryEvents &
    ElcServiceOrderEvents.ServiceOrderEvents &
    ElcServicePasswordStrengthEvents.ServicePasswordStrengthEvents &
    ElcServicePaymentEvents.ServicePaymentEvents &
    ElcServiceProdcatEvents.ServiceProdcatEvents &
    ElcServiceSaveForLaterEvents.ServiceSaveForLaterEvents &
    ElcServiceSearchEvents.ServiceSearchEvents &
    ElcServiceSignInEvents.ServiceSignInEvents &
    ElcServiceSignUpEvents.ServiceSignUpEvents &
    ElcServiceStoresEvents.ServiceStoresEvents &
    ElcServiceUserProfileEvents.ServiceUserProfileEvents &
    ElcServiceAnalyticsEvents.ServiceAnalyticsEvents &
    ElcServiceVtoEvents.ServiceVtoEvents &
    ElcServiceRatingsReviewsEvents.ServiceRatingsReviewsEvents &
    ElcCareEvents.CareEvents &
    ElcRampEvents.RampEvents &
    ElcVideoEvents.VideoEvents;

export { events, ServiceEvents };
